import React from 'react';

const View = ({ id }) => (
  <div>{id}</div>
);

export default View;
